import { QuizQuestion, QuizCategory } from '@shared/types';

// Quiz categories with colors
export const postDinnerQuizCategories: QuizCategory[] = [
  {
    name: "Experience & Atmosphere",
    color: "#0020cd", // Blue
    startIndex: 0,
    endIndex: 2
  },
  {
    name: "Future Intentions",
    color: "#0020cd", // Blue
    startIndex: 3,
    endIndex: 4
  },
  {
    name: "Final Note",
    color: "#0020cd", // Blue
    startIndex: 5,
    endIndex: 5
  }
];

// Base quiz questions
export const postDinnerQuizQuestions: QuizQuestion[] = [
  // Experience & Atmosphere (0-2)
  {
    id: "overallExperience",
    type: "scale",
    question: "How would you rate your overall experience?",
    scaleMin: 1,
    scaleMax: 5,
    scaleLabels: { min: "Poor", max: "Excellent" },
    required: true
  },
  {
    id: "feltWelcomed",
    type: "yesno",
    question: "Did you feel welcomed and comfortable at your table?",
    required: true
  },
  {
    id: "restaurantSelection",
    type: "single",
    question: "How was the restaurant selection?",
    options: [
      { value: "perfect", label: "Perfect choice", emoji: "✨" },
      { value: "good", label: "Good, enjoyed it", emoji: "👍" },
      { value: "okay", label: "It was okay", emoji: "🤷" },
      { value: "not-great", label: "Not my favorite", emoji: "😕" },
      { value: "poor", label: "Poor choice", emoji: "👎" }
    ],
    required: true
  },
  // Future Intentions (3-4)
  {
    id: "futureAttendance",
    type: "yesno",  
    question: "Would you attend another Outclose dinner in the next month?",
    required: true
  },
  {
    id: "recommendationScore",
    type: "scale",
    question: "How likely are you to recommend this dinner to a friend?",
    scaleMin: 1,
    scaleMax: 10,
    scaleLabels: { min: "Not likely", max: "Very likely" },
    required: true
  },
  // Final Note (5)
  {
    id: "notes",
    type: "text",
    question: "Any notes or anything you want to tell us?",
    required: false,
    multiline: true
  }
];

// Helper function to get current category
export const getCurrentCategory = (questionIndex: number): QuizCategory => {
  return postDinnerQuizCategories.find(cat => 
    questionIndex >= cat.startIndex && questionIndex <= cat.endIndex
  ) || postDinnerQuizCategories[0];
};

